"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));
var _mobx = require("mobx");
var _get2 = _interopRequireDefault(require("lodash/get"));
var _without2 = _interopRequireDefault(require("lodash/without"));
var _store = require("@tajawal/web-core-sdk-v2/lib/utils/store.utils");
var _hotelInfo = _interopRequireDefault(require("@tajawal/web-hotel-sdk-v2/lib/stores/hotel-info.store"));
var _mobxUtils = require("mobx-utils");
var _groupBy2 = _interopRequireDefault(require("lodash/groupBy"));
var _dateFns = require("date-fns");
var _sale = require("./sale.store");
var _saleFactory = require("../factories/sale-factory");
var _downloadOrderPdf = require("./download-order-pdf.store");
var _constants = require("../constants");
var _sale2 = require("../utils/sale.utils");
var _class; // import { OrderStore } from '@tajawal/ct-web-payment-sdk/lib/stores/api/order.store';
// import { DownloadOrderPdfStore } from '@tajawal/web-payment-sdk-v2/lib/stores/download-order-pdf.store';
/**
 * ManageHotelBookingStore
 */
let ManageHotelOrderBookingStore = (_class = /*#__PURE__*/function () {
  /**
   * constructor
   * @param {Object} initialState
   * @param {Object} $env
   */
  function ManageHotelOrderBookingStore(initialState = {}, $env) {
    (0, _classCallCheck2.default)(this, ManageHotelOrderBookingStore);
    /**
     * is fetched
     * @return {boolean}
     */
    this.hotelProduct = (0, _mobxUtils.computedFn)(orderNumber => {
      var _this$sale$data$booki;
      const bookings = (_this$sale$data$booki = this.sale.data.bookings) === null || _this$sale$data$booki === void 0 ? void 0 : _this$sale$data$booki.map(booking => (0, _saleFactory.saleFactory)(booking, this.$env));
      const hotel = bookings === null || bookings === void 0 ? void 0 : bookings.filter(booking => booking.orderNumber === orderNumber)[0];
      this.hotelBooking = hotel;
      return hotel;
    });
    this.$env = $env;
    this.updateInitialState(initialState);
    // // this.order = new OrderStore(initialState.order, $env);
    // this.order = new OrderStore(
    //   initialState.order,
    //   $env,
    //   makeHotelProductFactory()
    // );
    this.hotelInfo = new _hotelInfo.default(initialState.hotelInfo, $env);
    this.orderPdf = new _downloadOrderPdf.DownloadOrderPdfStore(initialState.orderPdf, $env);
    // this.staticResourcesStore = new StaticResourcesStore();
    this.sale = new _sale.MyAccountSaleStore(initialState.sale, $env);
  }

  /**
   * show manage booking
   * @return {boolean}
   */
  // @computed get showManageBooking() {
  //   return [
  //     END_USER_STATUS.CONFIRMED,
  //     END_USER_STATUS.PAYMENT_PENDING
  //   ].includes(this.order.hotel.endUserStatus);
  // }

  /**
   * update initial state
   * @param {Object} initialState
   */
  (0, _createClass2.default)(ManageHotelOrderBookingStore, [{
    key: "updateInitialState",
    value: function updateInitialState(initialState) {
      (0, _store.mapInitialStateToStoreState)(this, initialState);
    }
  }, {
    key: "isConfirmed",
    get: function () {
      var _this$hotelBooking;
      return (this === null || this === void 0 ? void 0 : (_this$hotelBooking = this.hotelBooking) === null || _this$hotelBooking === void 0 ? void 0 : _this$hotelBooking.displayStatus) === _constants.ALL_PRODUCT_BOOKING_STATUS.CONFIRMED;
    }
  }, {
    key: "options",
    get: function () {
      var _this$hotelBooking2, _this$hotelBooking2$p;
      const product = this === null || this === void 0 ? void 0 : (_this$hotelBooking2 = this.hotelBooking) === null || _this$hotelBooking2 === void 0 ? void 0 : (_this$hotelBooking2$p = _this$hotelBooking2.products) === null || _this$hotelBooking2$p === void 0 ? void 0 : _this$hotelBooking2$p.filter(product => product.type === this.hotelProduct.type)[0];
      return product === null || product === void 0 ? void 0 : product.options;
    }

    /**
     * is fully refundable
     * @return {boolean}
     */
  }, {
    key: "isFullyRefundable",
    get: function () {
      var _this$hotelBooking3, _this$hotelBooking3$p;
      return (0, _dateFns.isBefore)(new Date(), (_this$hotelBooking3 = this.hotelBooking) === null || _this$hotelBooking3 === void 0 ? void 0 : (_this$hotelBooking3$p = _this$hotelBooking3.product) === null || _this$hotelBooking3$p === void 0 ? void 0 : _this$hotelBooking3$p.firstCancellationDate);
    }

    /**
     * @typedef {Object} Reward
     * @property {number} value
     * @property {number} points
     * @property {Date} expiryDate
     * @property {string} method
     * @property {string} identifier
     *
     * reward
     * @return {Reward}
     */
  }, {
    key: "reward",
    get: function () {
      const reward = (0, _sale2.getSaleReward)(this.sale);
      return reward;
    }
  }]);
  return ManageHotelOrderBookingStore;
}(), ((0, _applyDecoratedDescriptor2.default)(_class.prototype, "updateInitialState", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "updateInitialState"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "isConfirmed", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isConfirmed"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "options", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "options"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "isFullyRefundable", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isFullyRefundable"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "reward", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "reward"), _class.prototype)), _class);
exports.default = ManageHotelOrderBookingStore;